module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box",
    class: _vm.wrapBgColor
  }, [_c('span', {
    staticClass: "info-box-icon",
    class: _vm.bgColor
  }, [_c('i', {
    class: _vm.bgIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.parseNumber))]), _vm._v(" "), (_vm.isProgress) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: (("width: " + _vm.percentage + "%"))
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v("\n      " + _vm._s(_vm.progressDescription) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78026bc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VAInfoBox.vue
// module id = 530
// module chunks = 1